export default function StatCard({ icon, label, value, sub, accent = '#00e5a0', onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: '#0d1520', border: '1px solid #1a2a3a', borderRadius: 12,
        padding: '20px 22px', cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.15s',
        display: 'flex', flexDirection: 'column', gap: 8,
      }}
      onMouseEnter={e => onClick && (e.currentTarget.style.borderColor = accent + '60')}
      onMouseLeave={e => onClick && (e.currentTarget.style.borderColor = '#1a2a3a')}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 36, height: 36, borderRadius: 9,
          background: accent + '18', border: `1px solid ${accent}30`,
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
          color: accent,
        }}>
          {icon}
        </div>
        <div style={{ fontSize: 11, color: '#3a5060', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.6px' }}>
          {label}
        </div>
      </div>
      <div style={{ fontSize: 28, fontWeight: 800, color: '#e8edf2', fontFamily: "'Syne',sans-serif", lineHeight: 1 }}>
        {value}
      </div>
      {sub && <div style={{ fontSize: 11, color: '#607080' }}>{sub}</div>}
    </div>
  );
}
